import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import upperFirst from 'lodash/upperFirst';
import isEmpty from 'lodash/isEmpty';

import { injectIntl } from 'react-intl';
import './styles.css';

import { ToolSetOptions, ToolSetOptionsItem } from '../../../../../../components/ToolSet';
import Link from '../../../../../../components/SEO/Link';
import { generateSearchPath } from '../../../../../../utils/urlHelpers/engines';

import { PortalConfigContext } from '../../../../../../config/portal';
import { getMessages } from '../../../../../../tppServices/translations/messages';

class FilterCategory extends PureComponent {
  handleDataChange(value, selected) {
    if (this.props.tracking) {
      this.props.tracking.facetRemoved(`category ${selected} removed`);
      this.props.tracking.facetAdded({'category': value});
    }

    this.props.handleDataChange('category', value);
  }

  renderCategoryOptions() {
    const { selectedCategory = '', categories = [], intl: { formatMessage: t }, position, params = {} } = this.props;
    const messages = getMessages();
    return (
      categories.map((category, i) => (
        <ToolSetOptionsItem
          key={`Category-${category.value}-all-${i}`}
          id={`Category-${category.value}-all`}
          name={`Category-${category.value}-${position}`}
          value={category.value}
          selected={selectedCategory === category.value}
          onClick={(value) => {
            this.handleDataChange(value, selectedCategory);
          }}>
          <Link className="category-type-link" href={generateSearchPath({ category: category.value }, params, true)} onClick={(e) => e.preventDefault()}>
            {upperFirst(t(messages.categoryFacetText[category.value]))}
          </Link>
        </ToolSetOptionsItem>
      ))
    );
  }

  render() {
    const { selectedCategory = '', intl: { formatMessage: t }, params = {} } = this.props;
    const messages = getMessages();
    return (
      <div className="search-filter category-filter">
        <ToolSetOptions>
          <ToolSetOptionsItem
            key="Category-all"
            id="Category-all"
            name="Category-all"
            value="all"
            selected={isEmpty(selectedCategory)}
            onClick={() => { this.handleDataChange('', selectedCategory); }}
          >
            <Link className="category-type-link" href={generateSearchPath({category: ''}, params, true)} onClick={(e) => e.preventDefault()}>
              {t(messages.all)}
            </Link>
          </ToolSetOptionsItem>
          {this.renderCategoryOptions()}
        </ToolSetOptions>
      </div>
    );
  }
}

FilterCategory.contextType = PortalConfigContext;

FilterCategory.propTypes = {
  selectedCategory: PropTypes.string,
  categories: PropTypes.array,
  handleDataChange: PropTypes.func.isRequired,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  params: PropTypes.shape({
    multiFacetedBoatTypeClass: PropTypes.object,
  }),
  position: PropTypes.oneOf(['desktop', 'mobile']),
  tracking: PropTypes.shape({
    facetAdded: PropTypes.func.isRequired,
    facetRemoved: PropTypes.func.isRequired,
  }),
};

export default injectIntl(FilterCategory);
